import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-container-groenafval',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconContainerGroenafval {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M26 2c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h1v-.04C4 .88 4.88 0 5.96 0H21a2 2 0 0 1 2 2zM10 31c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3m16.9-12.57c1.71 0 3.1-1.54 3.1-3.43 0-.55-.4-1-.9-1-1.71 0-3.1 1.54-3.1 3.43 0 .55.4 1 .9 1m6.71 2.95c.37-.33.46-.87.16-1.26-.66-.87-1.52-1.11-3.03-1.11-1.32 0-3.44.99-4.25.99h-.02c-.81 0-2.94-.99-4.25-.99-1.52 0-2.38.23-3.03 1.11-.29.39-.2.94.16 1.26 1.5 1.34 2.22 3.42 2.22 5.67 0 1.91-1.1 4.11-2.35 5.51-.3.34-.33.82-.08 1.2.89 1.32 2.16 2.24 3.09 2.24 1.3-.06 2.67-.97 4.25-.97V35h.02v.03c1.58 0 2.95.91 4.25.97.92 0 2.2-.92 3.09-2.24.25-.37.22-.86-.08-1.2-1.26-1.4-2.35-3.61-2.35-5.51 0-2.25.72-4.33 2.22-5.67ZM17.07 34c-.26-.95-.04-2 .65-2.77 1.07-1.19 1.84-2.95 1.84-4.18 0-1.8-.55-3.28-1.55-4.18-1.16-1.04-1.34-2.74-.42-3.96 1.18-1.56 2.74-1.86 4.29-1.89L22.99 7H4v20s.05-.02.07-.03c.83-.6 1.84-.97 2.94-.97 2.76 0 5 2.24 5 5 0 1.13-.39 2.16-1.02 3h6.1Z"/>
</svg>

    );
  }
}
